import script from "./GrouperBodyEmbedded.vue?vue&type=script&lang=ts&setup=true"
export * from "./GrouperBodyEmbedded.vue?vue&type=script&lang=ts&setup=true"

import "./GrouperBodyEmbedded.vue?vue&type=style&index=0&id=351435ae&lang=scss"

const __exports__ = script;

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QToolbar from 'quasar/src/components/toolbar/QToolbar.js';
import QTabs from 'quasar/src/components/tabs/QTabs.js';
import QTab from 'quasar/src/components/tabs/QTab.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTabPanel from 'quasar/src/components/tab-panels/QTabPanel.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QToolbar,QTabs,QTab,QSpace,QToggle,QTabPanel});
